export default "__VITE_ASSET__tTW1aNZa__"